import servise from '@/router/axios'

export const DauMenuList = (params) => {
  return servise({
    url: '/webDauConfig/one',
    method: 'get',
    params
  })
}
export const DauDetailList = (params) => {
  return servise({
    url: '/webDauConfig/detail/list',
    method: 'get',
    params
  })
}

export const addDau = (data) => {
  return servise({
    url: '/webDauConfig/add',
    method: 'post',
    data
  })
}

export const updateDau = (data) => {
  return servise({
    url: '/webDauConfig/update',
    method: 'PUT',
    data
  })
}

export const updateDauStatus = (data) => {
  return servise({
    url: '/webDauConfig/disable',
    method: 'PUT',
    data
  })
}

export const updateDauUniformPutStatus = (data) => {
  return servise({
    url: '/webDauConfig/uniformPut',
    method: 'PUT',
    data
  })
}

export const updateDauIgnoreQpsStatus = (data) => {
  return servise({
    url: '/webDauConfig/ignoreQps',
    method: 'PUT',
    data
  })
}
